import React, { useState } from "react";
import AavinImage from "../../assets/milk1.png";
import {
  CircularProgress,
  Grid,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomButton from "../Components/Button";
import { useMutation } from "react-query";
import { MilkClient } from "./mutations/milkCreation";
import { handleToastMsg } from "../Components/Toast";
import Input from "../Components/Input";
import CustomDivider from "../Components/CustomDivider"

const Outline = styled("p")`
  border: 1px solid #000;
  border-radius: 50px;
  padding: 25px;
  width: 25px;
  cursor: pointer;
  font-weight: bold;
  background: #1a1998;
  color: #fff;
  box-shadow: 1px 1px rgba(16, 24, 40, 0.12);
  font-size: 20px;
`;

function MilkComponent({ setModelToggle }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));
  const { mutate, isLoading } = useMutation(MilkClient);
  const [milkQuantity, setMilkQuantity] = useState("");

  const submitMilkRecord = () => {
    mutate(
      {
        quantity: milkQuantity,
      },
      {
        onSuccess: (res) => {
          console.log({ res }, "heyyyy");
          handleToastMsg("Data submitted successfully", "success");
          setMilkQuantity("");
          setModelToggle(false);
        },
        onError: (err) => {
          handleToastMsg(err.message, "error");
        },
      }
    );
  };

  return (
    <Grid container justifyContent={"center"}>
      <h4 style={{ textAlign: "center" }}>Milk Entry / பால்</h4>
      <CustomDivider />

      <Grid item container xs={12} alignItems={"center"} columnGap={1}>
        <Grid
          container
          item
          xs={12}
          md={3}
          justifyContent={isMobile && "center"}
        >
          <img src={AavinImage} alt="aavin-milk" height={250} width={250} />
        </Grid>
        <Grid item container xs={12} md={4} rowGap={2}>
          <Grid item xs={12} container justifyContent={isMobile && "center"}>
            <Outline
              onClick={() => {
                mutate(
                  {
                    quantity: 40,
                  },
                  {
                    onSuccess: (res) => {
                      console.log({ res }, "heyyyy");
                      handleToastMsg("Data submitted successfully", "success");
                      setMilkQuantity("");
                      setModelToggle(false);
                    },
                    onError: (err) => {
                      handleToastMsg(err.message, "error");
                    },
                  }
                );
              }}
            >
              +40
            </Outline>
          </Grid>
          <Grid item xs={10}>
            <h5>No . of Packet / பால் பாக்கெட்டுகள்</h5>
            <Input
              type="text"
              value={milkQuantity}
              onChange={(e) => setMilkQuantity(e.target.value)}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={12}
        justifyContent={isMobile ? "center" : "flex-end"}
        py={2}
      >
        <CustomButton onClick={submitMilkRecord} isLoading={isLoading}>
          "Submit / சமர்ப்பிக்க"
        </CustomButton>
      </Grid>
    </Grid>
  );
}

export default MilkComponent;
